import CommonUtil from '@/common/utils/CommonUtil'
import { Component, Vue } from 'vue-property-decorator'

import CAHG1220ViewModel from './CAHG1220ViewModel'
import CAHG1220Service from './CAHG1220Service'

import BreadcrumbsDisplay from '@/components/layout/breadcrumbs/Breadcrumbs.vue'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import TransportService from '@/common/TransportService'
import $ from 'jquery'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'
import Store from '@/common/utils/Store'

@Component({
  name: 'CAHG1220',
  components: {
  BreadcrumbsDisplay
  }
  })
export default class CAHG1220Controller extends Vue {
  /**
   * 年金受取額シミュレーション画面サービス
   */
  private cahg1220Service = new CAHG1220Service()

  private inputTextPlaceHolder = ''
  private inputValidateErr = false
  private inputValidateErrInfo = {
    // 年金受取開始時点の積立金額
    reservedAmountflg: false,
    reservedAmount: '',
    // 年金の受取開始年齢
    receiptStartAgeflg: false,
    receiptStartAge: '',
    // 年金の種類
    pensionTypeflg: false,
    pensionType: '',
    // 確定年金 年金の受け問期間
    receiptPeriodAcflg: false,
    receiptPeriodAc: '',
    // 終身年金 性別
    genderflg: false,
    gender: '',
    // 終身年金 終身年金の保証期間
    warrantyPeriodflg: false,
    warrantyPeriod: '',
    // 終身年金 生存期間
    receiptPeriodLaflg: false,
    receiptPeriodLa: '',
    // 分割取崩年金 年金の受取期間
    receiptPeriodIaflg: false,
    receiptPeriodIa: '',
    // 分割取崩年金 年金受取期間中の運用利回り
    investmentYieldflg: false,
    investmentYield: ''
  }
  private MESSAGE_VALIDATE_ITEM = 'message-validate-item'

  /**
   * 年金受取額シミュレーション画面モデル
   */
  private cahg1220ViewModel: CAHG1220ViewModel = {
    reservedAmount: '',
    receiptStartAge: '',
    pensionType: '',

    annuityLst: [],

    monthlyAnnuityLst: [],

    receiveTotalLst: [],

    receiptPeriodAc: '',

    gender: '',
    warrantyPeriod: '',
    receiptPeriodLa: '',

    receiptPeriodIa: '',
    investmentYield: '',

    dispFlg: false,
    loginFlg: false,

    showCalcAreaFlg: '',
    showAcCalcAreaFlg: '',
    showLaCalcAreaFlg: '',
    showLaCalcAreaAge: '',
    showIaCalcAreaFlg: '',
    showPensionTypeModalFlg: false,
    showWarrantyPeriodModalFlg: false,

    rsltDiv: null,

    receiptStartAgeLst: [],

    receiptPeriodLaLst: [],
    listMessageValidate: []
  }

  mounted() {
    const fullPath = this.$route.fullPath
    if (!CommonUtil.isWhiteUrl(fullPath)) {
      this.cahg1220ViewModel.loginFlg = true
    }
    this.$nextTick(() => {
      fixedContent()
      fixedContentNoLogin()
    })
    // 初期処理メソッドを呼出す
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    this.cahg1220ViewModel.reservedAmount = ''
    this.cahg1220ViewModel.receiptStartAge = ''
    this.cahg1220ViewModel.pensionType = ''
    this.cahg1220ViewModel.receiptPeriodAc = ''
    this.cahg1220ViewModel.gender = ''
    this.cahg1220ViewModel.warrantyPeriod = ''
    this.cahg1220ViewModel.receiptPeriodLa = ''
    this.cahg1220ViewModel.receiptPeriodIa = ''
    this.cahg1220ViewModel.investmentYield = ''

    /* 年金の受取開始年齢の選択肢をループで設定 */
    for (let i = 0; i < 16; i++) {
      this.cahg1220ViewModel.receiptStartAgeLst.push({
        id: i + 60 + '',
        value: String(i + 60)
      })
    }

    /* 生存期間（何歳まで受け取りますか？）の選択肢をループで設定 */
    for (let j = 0; j < 56; j++) {
      this.cahg1220ViewModel.receiptPeriodLaLst.push({
        id: j + 65 + '',
        value: String(j + 65)
      })
    }

    // システムアクティビティログを実行する（トランスポート）
    if (
      SessionStorageService.getItem(CommonConstants.USER_INFO) &&
      this.cahg1220ViewModel.loginFlg
    ) {
      TransportService.callAPITransport(
        CommonConstants.URL_CAHG1220,
        null,
        null
      )
    }
  }

  /*
   * 年金の種類ポップアップ呼び出し用メソッド
   */
  pensionTypeModalOpen() {
    // 表示用フラグがtrueの場合、ポップアップ表示します。
    this.cahg1220ViewModel.showPensionTypeModalFlg = true
    $('.el-dialog__close').attr('tabindex', '100')
  }

  /*
   * 年金の種類ポップアップ閉じ用メソッド
   */
  pensionTypeModalClose() {
    // 表示用フラグがfalseの場合、ポップアップを閉じます。
    this.cahg1220ViewModel.showPensionTypeModalFlg = false
  }

  /*
   * 年金の種類ポップアップ呼び出し用メソッド
   */
  warrantyPeriodModalOpen() {
    // 表示用フラグがtrueの場合、ポップアップ表示します。
    this.cahg1220ViewModel.showWarrantyPeriodModalFlg = true
    $('.el-dialog__close').attr('tabindex', '100')
  }

  /*
   * 年金の種類ポップアップ閉じ用メソッド
   */
  warrantyPeriodModalClose() {
    // 表示用フラグがfalseの場合、ポップアップを閉じます。
    this.cahg1220ViewModel.showWarrantyPeriodModalFlg = false
  }

  /*
   * 閉じる用コールバック メソッド
   */
  closeModalCallBack() {
    console.log('closeModalCallBack')
  }

  /*
   * 表示用コールバック メソッド
   */
  openModalCallBack() {
    console.log('openModalCallBack')
  }

  /**
   * シミュレーショントップに戻るボタン押下
   */
  private gotoCAHG1010() {
    this.$router.push({ name: 'cahg1010' })
  }

  /**
   * かんたんシミュレーショントップに戻るボタン押下
   */
  private gotoCAHG1130() {
    this.$router.push({ name: 'cahg1130' })
  }

  /**
   * 計算する、再計算するボタン押下
   */
  private async gotoCAHG1220() {
    /* 入力項目のチェック処理を呼び出す */
    const listErrorMessage = this.cahg1220Service.validationInput(
      this.cahg1220ViewModel.reservedAmount,
      this.cahg1220ViewModel.receiptStartAge,
      this.cahg1220ViewModel.pensionType,
      this.cahg1220ViewModel.receiptPeriodAc,
      this.cahg1220ViewModel.gender,
      this.cahg1220ViewModel.warrantyPeriod,
      this.cahg1220ViewModel.receiptPeriodLa,
      this.cahg1220ViewModel.receiptPeriodIa,
      this.cahg1220ViewModel.investmentYield
    )

    this.cahg1220ViewModel.listMessageValidate = listErrorMessage

    if (listErrorMessage.length > 0) {
      /* 入力項目チェックにエラーがあった場合、計算結果エリアを表示させない */
      this.cahg1220ViewModel.dispFlg = false
      this.inputValidateErr = true
      this.inputTextPlaceHolder = '入力してください'

      /* 入力項目チェックエラー項目情報初期化 */
      this.inputValidateErrInfoClear()

      /* 入力項目チェックエラー項目情報設定 */
      this.setInputValidateErrInfoFlg(listErrorMessage)
    } else {
      this.inputValidateErr = false
      this.inputTextPlaceHolder = ''
      /*
            入力項目チェックにエラーがなかった場合、年金受取額シミュレーション計算結果取得（CAHA1220）を呼ぶ
            */
      const caha1220ResponseModel = await this.cahg1220Service.callAPICAHA1220(
        this.cahg1220ViewModel.reservedAmount,
        this.cahg1220ViewModel.receiptStartAge,
        this.cahg1220ViewModel.pensionType,
        this.cahg1220ViewModel.receiptPeriodAc,
        this.cahg1220ViewModel.gender,
        this.cahg1220ViewModel.warrantyPeriod,
        this.cahg1220ViewModel.receiptPeriodLa,
        this.cahg1220ViewModel.receiptPeriodIa,
        this.cahg1220ViewModel.investmentYield
      )

      /* APIを呼び出し、エラーがなかった場合に項目をViewModelの値に設定する */
      if (caha1220ResponseModel.rsltDiv === 1) {
        /* レスポンス項目に対応するViewModelを初期化する */
        this.cahg1220ViewModel.annuityLst = []
        this.cahg1220ViewModel.monthlyAnnuityLst = []
        this.cahg1220ViewModel.receiveTotalLst = []
        Store.setResponseErrors(null)
        if (
          !CommonUtil.isNotEmpty(caha1220ResponseModel.annuityLst) ||
          !CommonUtil.isNotEmpty(caha1220ResponseModel.monthlyAnnuityLst) ||
          !CommonUtil.isNotEmpty(caha1220ResponseModel.receiveTotalLst)
        ) {
          this.cahg1220ViewModel.dispFlg = false
          const errorValid = []
          errorValid.push({
            code: 'MSGCAHG1220WF029',
            message: CommonUtil.getMessage('MSGCAHG1220WF029', [])
          })
          Store.setResponseErrors(errorValid)
          return
        }
        /* APIのレスポンス項目をViewModelに設定する */
        for (let k = 0; k < 4; k++) {
          this.cahg1220ViewModel.annuityLst.push(
            String(caha1220ResponseModel.annuityLst[k])
          )
          this.cahg1220ViewModel.monthlyAnnuityLst.push(
            String(caha1220ResponseModel.monthlyAnnuityLst[k])
          )
          this.cahg1220ViewModel.receiveTotalLst.push(
            String(caha1220ResponseModel.receiveTotalLst[k])
          )
        }

        /* APIを呼び出し、エラーがなかった場合に計算結果エリアを表示させる */
        this.cahg1220ViewModel.dispFlg = true

        /* 年金の種類ごとの計算結果エリアの表示制御をするためのフラグに値を設定 */
        this.cahg1220ViewModel.showCalcAreaFlg =
          this.cahg1220ViewModel.pensionType

        /* 確定年金計算結果エリアの表示制御をするためのフラグに値を設定 */
        this.cahg1220ViewModel.showAcCalcAreaFlg =
          this.cahg1220ViewModel.receiptPeriodAc

        /* 終身年金計算結果エリアの表示制御をするためのフラグに値を設定 */
        this.cahg1220ViewModel.showLaCalcAreaFlg =
          this.cahg1220ViewModel.warrantyPeriod

        /* 終身年金計算結果エリアの年齢表示制御をするためのフラグに値を設定 */
        this.cahg1220ViewModel.showLaCalcAreaAge =
          this.cahg1220ViewModel.receiptPeriodLa

        /* 分割取崩年金計算結果エリアの表示制御をするためのフラグに値を設定 */
        this.cahg1220ViewModel.showIaCalcAreaFlg =
          this.cahg1220ViewModel.receiptPeriodIa
      } else {
        /* APIを呼び出し、エラーがあった場合に計算結果エリアを表示させない */
        this.cahg1220ViewModel.dispFlg = false
      }
    }
    this.scrollToTop()
  }

  private scrollToTop() {
    $('html, body').animate(
      {
        scrollTop: 0
      },
      0
    )
  }

  private inputValidateErrInfoClear() {
    // 年金受取開始時点の積立金額
    this.inputValidateErrInfo.reservedAmountflg = false
    this.inputValidateErrInfo.reservedAmount = ''
    // 年金の受取開始年齢
    this.inputValidateErrInfo.receiptStartAgeflg = false
    this.inputValidateErrInfo.receiptStartAge = ''
    // 年金の種類
    this.inputValidateErrInfo.pensionTypeflg = false
    this.inputValidateErrInfo.pensionType = ''
    // 確定年金 年金の受け問期間
    this.inputValidateErrInfo.receiptPeriodAcflg = false
    this.inputValidateErrInfo.receiptPeriodAc = ''
    // 終身年金 性別
    this.inputValidateErrInfo.genderflg = false
    this.inputValidateErrInfo.gender = ''
    // 終身年金 終身年金の保証期間
    this.inputValidateErrInfo.warrantyPeriodflg = false
    this.inputValidateErrInfo.warrantyPeriod = ''
    // 終身年金 生存期間
    this.inputValidateErrInfo.receiptPeriodLaflg = false
    this.inputValidateErrInfo.receiptPeriodLa = ''
    // 分割取崩年金 年金の受取期間
    this.inputValidateErrInfo.receiptPeriodIaflg = false
    this.inputValidateErrInfo.receiptPeriodIa = ''
    // 分割取崩年金 年金受取期間中の運用利回り
    this.inputValidateErrInfo.investmentYieldflg = false
    this.inputValidateErrInfo.investmentYield = ''
  }

  private setInputValidateErrInfoFlg(listErrorMessage) {
    listErrorMessage.forEach((errorValid) => {
      // エラーメッセージに該当する場合、エラー有（ture）を設定
      // 年金受取開始時点の積立金額
      if (errorValid.code === 'MSGCAHG1220WF001' ||
          errorValid.code === 'MSGCAHG1220WF002' ||
          errorValid.code === 'MSGCAHG1220WF003') {
        this.inputValidateErrInfo.reservedAmountflg = true
      }
      // 年金の受取開始年齢
      if (errorValid.code === 'MSGCAHG1220WF004' ||
          errorValid.code === 'MSGCAHG1220WF005' ||
          errorValid.code === 'MSGCAHG1220WF006') {
        this.inputValidateErrInfo.receiptStartAgeflg = true
      }
      // 年金の種類
      if (errorValid.code === 'MSGCAHG1220WF007' ||
          errorValid.code === 'MSGCAHG1220WF008' ||
          errorValid.code === 'MSGCAHG1220WF009') {
        this.inputValidateErrInfo.pensionTypeflg = true
      }
      // 確定年金 年金の受け問期間
      if (errorValid.code === 'MSGCAHG1220WF010' ||
          errorValid.code === 'MSGCAHG1220WF011' ||
          errorValid.code === 'MSGCAHG1220WF012') {
        this.inputValidateErrInfo.receiptPeriodAcflg = true
      }
      // 終身年金 性別
      if (errorValid.code === 'MSGCAHG1220WF013' ||
          errorValid.code === 'MSGCAHG1220WF014' ||
          errorValid.code === 'MSGCAHG1220WF015') {
        this.inputValidateErrInfo.genderflg = true
      }
      // 終身年金 終身年金の保証期間
      if (errorValid.code === 'MSGCAHG1220WF016' ||
          errorValid.code === 'MSGCAHG1220WF017' ||
          errorValid.code === 'MSGCAHG1220WF018') {
        this.inputValidateErrInfo.warrantyPeriodflg = true
      }
      // 終身年金 生存期間
      if (errorValid.code === 'MSGCAHG1220WF019' ||
          errorValid.code === 'MSGCAHG1220WF020' ||
          errorValid.code === 'MSGCAHG1220WF021' ||
          errorValid.code === 'MSGCAHG1220WF022') {
        this.inputValidateErrInfo.receiptPeriodLaflg = true
      }
      // 分割取崩年金 年金の受取期間
      if (errorValid.code === 'MSGCAHG1220WF023' ||
          errorValid.code === 'MSGCAHG1220WF024' ||
          errorValid.code === 'MSGCAHG1220WF025') {
        this.inputValidateErrInfo.receiptPeriodIaflg = true
      }
      // 分割取崩年金 年金受取期間中の運用利回り
      if (errorValid.code === 'MSGCAHG1220WF026' ||
          errorValid.code === 'MSGCAHG1220WF027' ||
          errorValid.code === 'MSGCAHG1220WF028') {
        this.inputValidateErrInfo.investmentYieldflg = true
      }
    })

    // 入力項目チェックエラーの項目にCSSを設定
    this.setInputValidateErrInfoCss()
  }

  private setInputValidateErrInfoCss() {
    // 年金受取開始時点の積立金額
    if (this.inputValidateErrInfo.reservedAmountflg) {
      this.inputValidateErrInfo.reservedAmount = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.reservedAmount = ''
    }
    // 年金の受取開始年齢
    if (this.inputValidateErrInfo.receiptStartAgeflg) {
      this.inputValidateErrInfo.receiptStartAge = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.receiptStartAge = ''
    }
    // 年金の種類
    if (this.inputValidateErrInfo.pensionTypeflg) {
      this.inputValidateErrInfo.pensionType = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.pensionType = ''
    }
    // 確定年金 年金の受け問期間
    if (this.inputValidateErrInfo.receiptPeriodAcflg) {
      this.inputValidateErrInfo.receiptPeriodAc = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.receiptPeriodAc = ''
    }
    // 終身年金 性別
    if (this.inputValidateErrInfo.genderflg) {
      this.inputValidateErrInfo.gender = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.gender = ''
    }
    // 終身年金 終身年金の保証期間
    if (this.inputValidateErrInfo.warrantyPeriodflg) {
      this.inputValidateErrInfo.warrantyPeriod = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.warrantyPeriod = ''
    }
    // 終身年金 生存期間
    if (this.inputValidateErrInfo.receiptPeriodLaflg) {
      this.inputValidateErrInfo.receiptPeriodLa = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.receiptPeriodLa = ''
    }
    // 分割取崩年金 年金の受取期間
    if (this.inputValidateErrInfo.receiptPeriodIaflg) {
      this.inputValidateErrInfo.receiptPeriodIa = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.receiptPeriodIa = ''
    }
    // 分割取崩年金 年金受取期間中の運用利回り
    if (this.inputValidateErrInfo.investmentYieldflg) {
      this.inputValidateErrInfo.investmentYield = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.investmentYield = ''
    }
  }
}
